import React, { FCX } from 'react';
import styled from '@emotion/styled';
import BackgroundImage from 'gatsby-background-image';
import Img from 'gatsby-image';
import { useAnyImage } from 'src/hooks';
import { Inducer } from 'src/components';
import { GatsbyLinkButton } from 'src/components/common/molecules';

const Avatar: FCX = ({ className }) => {
  const image = useAnyImage('avatar_body.png')!;

  return <Img className={className} fluid={image} />;
};

const StyledAvatar = styled(Avatar)`
  width: 16.667em;
  height: 16.667em;
  filter: drop-shadow(16px 0 var(--color-secondary-dark));
`;

const Background: React.FCX = ({ className, children }) => {
  const image = useAnyImage('pastel2.jpg')!;

  return (
    <BackgroundImage className={className} fluid={image}>
      <div>{children}</div>
    </BackgroundImage>
  );
};

const StyledBackground = styled(Background)`
  min-height: 100vh;
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;

  & > div {
    &:before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.07);
      background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.15) 50%, transparent 50%),
        linear-gradient(rgba(0, 0, 0, 0.15) 50%, transparent 50%);
      background-size: 2px 2px;
      z-index: -1;
    }
  }
`;

const Component: FCX = ({ className }) => {
  return (
    <>
      <StyledBackground>
        <div className={className}>
          <StyledAvatar />
          <h1>Ribbit</h1>
          <p>Front-End Engineer. Open source contributor</p>
          <GatsbyLinkButton to='/contact/' title='CONTACT' />
        </div>
        <Inducer from='transparent' to='#fff' />
      </StyledBackground>
    </>
  );
};

const StyledComponent = styled(Component)`
  width: 100%;
  height: 80vh;
  padding-top: 50px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1,
  p {
    line-height: 1.25em;
    font-weight: 700;
    text-align: center;
    letter-spacing: 2px;
    color: #fff;
  }

  p {
    font-size: 185%;
  }
`;

export default StyledComponent;
